<template>
  <div>
    <base-card :loading="loading" class="rounded-lg">
      <party-header-navigation-bar :party="party" type="reports" />
      <v-tabs v-model="tab" show-arrows class="rounded-lg" height="36px">
        <v-tab
          v-for="tab in loading ? [] : tabsFiltered"
          class="rounded-lg"
          :key="tab.component"
        >
          <v-icon left small>{{ tab.icon }}</v-icon>
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        :touchless="tabsFiltered[tab]?.touchless"
        class="rounded-b-xl"
      >
        <v-tab-item
          v-for="item in loading ? [] : tabsFiltered"
          :key="item.name"
        >
          <component
            :is="item.component"
            :party="party"
            @refresh="getReportData"
            class="px-4 pb-4"
            :firstLoad="firstLoad"
            :loading="reportLoading"
            :error="error"
            :lastUpdate="lastUpdate"
            :blockRefresh="blockRefresh"
            :refreshKey="refreshKey"
            :tickets="reportData.tickets"
            :payments="reportData.payments"
            :ticketGroups="ticketGroups"
            :posSellers="posSellers"
            :saleLinks="saleLinks"
            :sellers="sellers"
            :ticketBlockMap="ticketBlockMap"
          />
        </v-tab-item>
      </v-tabs-items>
    </base-card>

    <refund-ticket :party="party" />
    <tecnician-daily :party="party" />

    <!-- Navgation  -->
    <v-bottom-sheet
      v-model="navigationSheet"
      inset
      max-width="550px"
      :overlay-opacity="0.8"
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          style="position: fixed; bottom: 76px; right: 16px; z-index: 5"
          float
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          <v-icon> mdi-dots-grid </v-icon>
        </v-btn>
      </template>
      <div class="mb-4 px-4 d-flex">
        <v-card class="pa-3 pb-1 rounded-lg">
          <v-row dense class="mx-0">
            <v-col
              v-for="tab in tabsFiltered"
              :key="tab?.id"
              cols="4"
              sm="4"
              md="3"
            >
              <v-card
                @click="selectTab(tab?.id)"
                outlined
                height="90px"
                elevation="0"
                class="pa-2"
              >
                <div
                  class="d-flex align-center justify-center flex-column h-full text-center lh-1 gap-2"
                >
                  <v-icon>{{ tab.icon }}</v-icon>
                  {{ tab.name }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div class="d-flex justify-center">
            <v-btn @click="navigationSheet = false" text small> Fechar </v-btn>
          </div>
        </v-card>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TICKET from "@/services/admin/ticket";
import SELLER from "@/services/admin/party/seller";
import ORGANIZATION from "@/services/admin/organization";
import paymentService from "@/services/admin/report";

import RefundTicket from "@/components/admin/modals/RefundTicket.vue";
import PartyTickets from "@/components/admin/party/PartyTicketsSold.vue";
import PartyReports from "@/components/admin/party/PartyReports.vue";
import PartyResumeReport from "@/components/admin/party/PartyResumeReport.vue";
import PartyLiveAnalytics from "@/components/admin/party/PartyLiveAnalytics.vue";
import TecnicianDaily from "@/components/global/tecnician/TecnicianDaily.vue";
import PartyHeaderNavigationBar from "./modules/PartyHeaderNavigationBar.vue";
import PartyFinancial from "@/components/admin/party/PartyFinancial.vue";
import PartyUTM from "@/components/admin/party/PartyUTM.vue";

export default {
  metaInfo() {
    return { title: `⚙️ ${this.party?.name || "Carregando..."}` };
  },
  data: () => ({
    loading: true,
    party: null,
    tab: null,
    navigationSheet: false,
    tabs: [
      {
        id: "reports",
        name: "Relatórios",
        component: "PartyReports",
        permission: 512,
        icon: "mdi-chart-bar",
        touchless: true,
        noFree: true,
      },
      {
        id: "resume",
        name: "Resumo",
        component: "PartyResumeReport",
        permission: 512,
        icon: "mdi-table-large",
        touchless: true,
        noFree: true,
      },
      {
        id: "guests",
        name: "Convidados",
        component: "PartyTickets",
        permission: 64,
        icon: "mdi-account-multiple",
        touchless: true,
        noFree: true,
      },
      {
        id: "analytics",
        name: "Analytics",
        component: "PartyLiveAnalytics",
        permission: 512,
        icon: "mdi-chart-line",
        touchless: true,
      },
      {
        id: "utm",
        name: "UTM",
        component: "PartyUTM",
        permission: 512,
        icon: "mdi-chart-tree",
        touchless: true,
        noFree: true,
      },
      {
        id: "financial",
        name: "Financeiro",
        component: "PartyFinancial",
        permission: [2048, 4096],
        icon: "mdi-cash-multiple",
        touchless: true,
        noFree: true,
      },
    ],

    // Report data
    refreshKey: 0,
    reportLoading: true,
    blockRefresh: false,
    error: false,
    firstLoad: false,
    paymentsSubscription: null,
    ticketGroups: [],
    posSellers: [],
    saleLinks: [],
    sellers: [],
    ticketBlockMap: new Map(),
    reportData: {},
    lastUpdate: null,
    timeout: null,
  }),
  methods: {
    ...mapActions("organization", ["partyById"]),
    async getParty() {
      try {
        this.loading = true;
        var response = await this.partyById(this.$route.params.partyId);
        this.party = response;
        this.loading = false;
        this.tab = 0;
        this.selectTab();
        this.$root.$emit("setImgBg", this.party?.cover);
      } catch (error) {
        this.$router.push({ name: "admin.parties" });
      }
    },
    selectTab(tab) {
      if (tab) window.location.replace("#" + tab);
      if (this.$route.hash) {
        let hash = tab || this.$route.hash.replace("#", "");
        let index = this.tabsFiltered.findIndex((tab) => tab?.id == hash);
        if (index >= 0) this.tab = index;
        this.navigationSheet = false;
      }
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(50);
    },
    async getSellers() {
      try {
        const { sellers, posSellers } = await SELLER.getAll(
          this.party.organizationId,
          this.party.id,
          { includeDisconnected: true }
        ).catch(() => ({ sellers: [], posSellers: [] }));

        this.sellers = sellers.map((s) => ({
          id: s.id,
          name: s.name,
          photo: s.photo,
          type: "user",
        }));

        this.posSellers = posSellers.map((pos) => ({
          ...pos,
          id: pos.id,
          type: pos.partyId ? "ticketOffice" : "pos",
          Address: { name: pos.name || pos.Address?.name },
          type: "pos",
        }));
      } catch (error) {
        this.error = error;
      }
    },
    async getTicketGroups() {
      try {
        const response = await TICKET.getTickets(
          this.party.organizationId,
          this.party.id,
          { childrenParty: true, noTicketsSold: true, noSellers: true }
        );
        this.ticketGroups = response.ticketGroups;

        const tbMap = new Map();
        response.ticketGroups.forEach((tg) => {
          tg.TicketBlock.forEach((tb) => {
            tbMap.set(tb.id, {
              id: tb.id,
              name: tb.name,
              price: tb.price,
              TicketGroup: {
                id: tg.id,
                name: tg.name,
                partytId: tg.partytId,
              },
            });
          });
        });

        this.ticketBlockMap = tbMap;
      } catch (e) {
        console.error(e);
      }
    },
    async getSaleLinks() {
      try {
        const { saleLinks } = await ORGANIZATION.party.saleLink
          .getAll(this.party.organizationId, this.party.id)
          .catch(() => ({ saleLinks: [] }));

        this.saleLinks = saleLinks;
      } catch (error) {
        this.error = error;
      }
    },
    async subscribePayments() {
      this.paymentsSubscription = paymentService
        .getPayments(this.party.organizationId, this.party.id)
        .subscribe((response) => {
          const tickets = [];
          this.reportData.payments = response.payments.map((p) => {
            const Tickets = p.Ticket.map((t) => {
              const tb = this.ticketBlockMap.get(t.ticketBlockId);
              const ticket = { ...t, TicketBlock: tb, Payment: p };
              tickets.push(ticket);
              return ticket;
            });
            return { ...p, Ticket: Tickets };
          });
          this.reportData.tickets = tickets;
          this.lastUpdate = response.lastUpdate;
          this.refreshKey++;
          this.firstLoad = true;
        });
    },
    async getReport() {
      try {
        clearTimeout(this.timeout);
        this.error = null;
        this.reportLoading = true;
        this.blockRefresh = true;

        await paymentService.updatePayments(
          this.party.organizationId,
          this.party.id
        );

        this.enableRefresh(10000);
      } catch (e) {
        this.error = e.message || "Erro ao carregar relatório";
        this.enableRefresh(5000);
      } finally {
        this.reportLoading = false;
        this.setTimeout();
      }
    },
    async getReportData() {
      return Promise.all([this.getTicketGroups(), this.getReport()]);
    },
    async setTimeout() {
      this.timeout = setTimeout(() => {
        this.getReportData();
      }, 3 * 60 * 1000);
    },
    enableRefresh(time) {
      setTimeout(() => {
        this.blockRefresh = false;
      }, time);
    },
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization"]),
    ...mapGetters("auth", ["hasPermission"]),
    tabsFiltered() {
      return this.tabs.filter((tab) => {
        if (this.party?.isFree && tab.noFree) return false;
        if (!tab.permission) return true;
        return this.hasPermission(tab.permission);
      });
    },
  },
  watch: {
    tab: {
      handler(val, oldVal) {
        if (val !== null && oldVal !== null) this.vibrate();
        let tab = this.tabsFiltered[val];
        if (tab) window.location.replace("#" + tab?.id);
      },
      immediate: true,
    },
    "$route.hash"() {
      this.selectTab();
    },
    "$route.params.partyId"() {
      this.getParty();
    },
    "selectedOrganization.id"() {
      this.$router.push({
        name: "admin.parties",
      });
    },
  },
  components: {
    TecnicianDaily,
    RefundTicket,
    PartyTickets,
    PartyReports,
    PartyFinancial,
    PartyUTM,
    PartyResumeReport,
    PartyLiveAnalytics,
    PartyHeaderNavigationBar,
  },
  destroyed() {
    this.$root.$emit("setImgBg", null);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.paymentsSubscription?.unsubscribe();
  },
  async mounted() {
    await this.getParty();
    this.subscribePayments();
    await this.getTicketGroups();
    await this.getReport();
    await Promise.all([this.getSellers(), this.getSaleLinks()]);
  },
};
</script>

<style></style>
